import {
  INewRouteApplicationDetail,
  INewRouteReceiver,
  INewRouteReply,
} from "./newRouteApplicationDetail.types";

export class NewRouteApplicationDetail implements INewRouteApplicationDetail {
  uid?: string;
  title: string;
  bodyText: string;
  memberUid: string;
  memberName: string;
  employeeNo: string;
  serviceUid: string;
  campusCode: string;
  campusName: string;
  workTimeCode: string;
  workTimeName: string;
  talkLineWeekdayCode: string;
  talkLineWeekdayName: string;
  lineDirectionCode: string;
  lineDirectionName: string;
  displayYn: boolean;
  roadAddress: string;
  detailAddress: string;
  dongAddress: string;
  lat: number;
  lng: number;
  receiverCount: number;
  receivers: INewRouteReceiver[];
  replies: INewRouteReply[];
  statusCode: string;
  statusName: string;
  talkTypeCode: string;
  useBeginDtm: string;
  useEndDtm?: string;
  savedTs?: string;
  updatedTs?: string;
  createdTs?: string;

  constructor(data: INewRouteApplicationDetail) {
    this.uid = data.uid;
    this.title = data.title;
    this.bodyText = data.bodyText;
    this.memberUid = data.memberUid;
    this.memberName = data.memberName;
    this.employeeNo = data.employeeNo;
    this.serviceUid = data.serviceUid;
    this.campusCode = data.campusCode;
    this.campusName = data.campusName;
    this.workTimeCode = data.workTimeCode;
    this.workTimeName = data.workTimeName;
    this.talkLineWeekdayCode = data.talkLineWeekdayCode;
    this.talkLineWeekdayName = data.talkLineWeekdayName;
    this.lineDirectionCode = data.lineDirectionCode;
    this.lineDirectionName = data.lineDirectionName;
    this.displayYn = data.displayYn;
    this.roadAddress = data.roadAddress;
    this.detailAddress = data.detailAddress;
    this.dongAddress = data.dongAddress;
    this.lat = data.lat;
    this.lng = data.lng;
    this.receiverCount = data.receiverCount;
    this.receivers = data.receivers;
    this.replies = data.replies;
    this.statusCode = data.statusCode;
    this.statusName = data.statusName;
    this.talkTypeCode = data.talkTypeCode;
    this.useBeginDtm = data.useBeginDtm;
    this.useEndDtm = data.useEndDtm;
    this.savedTs = data.savedTs;
    this.updatedTs = data.updatedTs;
    this.createdTs = data.createdTs;
  }
}
